import { render, staticRenderFns } from "./NotebookItem.vue?vue&type=template&id=11819278&scoped=true"
import script from "./NotebookItem.vue?vue&type=script&lang=ts"
export * from "./NotebookItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11819278",
  null
  
)

export default component.exports